const w = window

export const origin = w.location.origin
export const protocol = w.location.protocol
export const pathname = w.location.pathname
export const hostName = w.location.hostname.split("-")

// ?id=123 return '123'
export const queryByName = (name) => {
  var match = RegExp("[?&]" + name + "=([^&]*)").exec(w.location.search)
  return match && decodeURIComponent(match[1].replace(/\+/g, " "))
}
// url/abc/1234 return ['url', 'abc', '1234']
export const getParameterArr = (url) => {
  const currentPath = url ? url : w.location.pathname
  return currentPath.replace(/^([^/])/, "/$1").split("/")
}
// get mygogoro url
export const myGogoroUrl = (name) => {
  const _name = name ? name : ""
  switch (hostName[0]) {
    case "local": {
      return protocol + "//local-my.gogoro.com/tw/" + _name
    }

    case "dev": {
      return protocol + "//dev-my.gogoro.com/tw/" + _name
    }

    case "qas": {
      return protocol + "//dev-my.gogoro.com/tw/" + _name
    }

    case "pa": {
      return protocol + "//qas-my.gogoro.com/tw/" + _name
      // return protocol + '//pa-app-my.gogoro.com/tw/' + _name;
    }

    default:
      return protocol + "//my.gogoro.com/tw/" + _name
  }
}
